// @flow
import * as React from 'react';
import type { TPlayersById } from '../../modules/types';
import {
	TradeInCell,
	TradeOutCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
	ButtonSecondary
} from '../';

type Props = {
	players_by_id: TPlayersById,
	trade: Object,
	rejectTrade: Function
}
export const TradeFromUser = ({ trade, players_by_id, rejectTrade }: Props) => {
	const { id: trade_id, new_player_id, old_player_id, new_team_name, status } = trade;
	return (
		<TransactionPlayersWrapper>
			<TransactionPlayers>
				<p>
					You have requested from {new_team_name}:
				</p>
				{new_player_id.map(id => (<TradeInCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
			{status === 'accepted' ? null : (
				<div>
					<ButtonSecondary onClick={() => rejectTrade({ trade_id })}>
						CANCEL OFFER
					</ButtonSecondary>
				</div> )}
			<TransactionPlayers>
				<p>
					& offered:
				</p>
				{old_player_id.map(id => (<TradeOutCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
		</TransactionPlayersWrapper>
	);
};

export default TradeFromUser;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeFromUser.js